var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vacancy"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":_vm.compData.link}},[_vm._v(_vm._s(_vm.compData.title))]),_c('p',[_vm._v(_vm._s(_vm.compData.location))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }